import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import { useForm } from 'react-hook-form'

import TextGroup, { Image } from '../Texts'
import { TestimonialSmall } from '../Testimonial'
import Turnstile from '../Turnstile'

import c_logo1 from '../../assets/images/company-logos/hp.svg'
import c_logo2 from '../../assets/images/company-logos/nos.svg'
import c_logo3 from '../../assets/images/company-logos/nova.svg'
import c_logo4 from '../../assets/images/company-logos/sonae.svg'
import c_logo5 from '../../assets/images/company-logos/sportzone.svg'
import c_logo6 from '../../assets/images/company-logos/worten.svg'

const companies = [
	{
		image: c_logo3,
		title: 'NOVA',
	},
	{
		image: c_logo1,
		title: 'HP',
	},

	{
		image: c_logo5,
		title: 'SPORTZONE',
	},
	{
		image: c_logo2,
		title: 'NOS',
	},
	{
		image: c_logo6,
		title: 'WORTEN',
	},
	{
		image: c_logo4,
		title: 'SONAE',
	},
];

let testimonial;

const ContactOne = ({ lang }) => {
	const isEn = lang === 'en';
	const testimonials = [
		{
			text:
				isEn ? 'log is an extraordinary partner. We had the opportunity to work together on designing a website for our brokers, and we have no words to describe the team\'s dedication and professionalism. If more opportunities arise in the future, I will not hesitate to work together with log.' : 'A log é um parceiro extraordinário. Tivemos a oportunidade de trabalhar juntos na criação de um website para os nossos corretores, e não temos palavras para descrever a dedicação e profissionalismo da equipa. Se surgirem mais oportunidades no futuro, não hesitarei em trabalhar com a log.',
			company: 'Ageas',
			person: 'Soraia Alves',
		},
		{
			text:
				isEn ? 'The log team has worked with us since we came to Portugal in 2020. As agency demands vary rapidly, they have shown tremendous flexibility in accommodating our needs, finding great talent, and delivering impactful work for our clients.' : 'A equipa da log trabalha connosco desde que chegámos a Portugal em 2020. Como as necessidades de agências variam rapidamente, a equipa mostrou uma flexibilidade tremenda no que toca a responder às nossas necessidades, a encontrar grandes talentos e a entregar trabalhos de impacto para os nossos clientes.',
			company: 'Bynd',
			person: 'Cassiano Surek',
		},
		{
			text:
				isEn ? 'log helped us from the very first hour of development of our new website. The work was exhaustive and started with the UX project. With a pandemic in the middle, the challenges were enormous during the implementation phase, but the working method with 10-day work steps allowed monitoring the development of the project and making adjustments in real time.' : 'A log ajudou-nos desde a primeira hora de desenvolvimento do nosso novo website. O trabalho foi aprofundado e começou pelo projeto de UX. Com uma pandemia pelo meio, os desafios na fase de implementação foram enormes, mas o método de trabalho com passos de 10 dias permitiu monitorizar o desenvolvimento do projeto e fazer ajustes em tempo real.',
			company: 'Kicks',
			person: 'José Vieira',
		},
		{
			text:
				isEn ? 'In 2018, we picked log as the developer of the new site for Grupo FILINTO MOTA, and we couldn\'t be more satisifed with the final result and the project\'s entire unfolding. Since then, log has become a reliable and trustworthy partner capable of making all of our ideas a reality, from the simplest to the most complex ones.' : 'Em 2018, escolhemos a log para o desenvolvimento do novo site do Grupo FILINTO MOTA, e não podíamos estar mais satisfeitos com o resultado final e com o desenrolar de todo o projecto. Desde então, a log assumiu-se como um parceiro fiável e de confiança, capaz de transformar todas as nossas ideias, da mais simples à mais complexa, em realidade.',
			company: 'Filinto Mota',
			person: 'Pedro Dias',
		},
	];

	const [message, setMessage] = useState({
		status: null,
		content: '',
	});

	const { error, register, handleSubmit, reset } = useForm();
	const [turnstileToken, setTurnstileToken] = useState('');

	// Post data to our Workers application
	const onSubmit = async (data) => {
		const url = 'https://contact.log.pt/';
		try {
			const response = await fetch(url, {
				method: 'POST',
				mode: 'cors',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ ...data, turnstileToken }),
			})

			const results = await response.json()

			setMessage({
				status: response.status,
				content: results.message,
			})

			if (response.status === 200 || response.status === 202) {
				reset()
			}
		} catch {
			setMessage({
				status: 500,
				content: 'Fatal error',
			})
		}
	}


	useEffect(() => {
		testimonial = testimonials[Math.floor(Math.random() * testimonials.length)];
		document.getElementsByClassName('testimonial-small')[0].classList.remove('off');
	}, [typeof document !== 'undefined' && document.getElementById('#header')]);

	return (
		<section id="contact-one" className="content container medium">
			<div className="row">
				<TextGroup
					rootProps={{ className: '' }}
					title={{
						type: 'h1',
						text: isEn ? "Let's get the conversation started" : 'Vamos conversar?',
					}}
				/>
				<div className="row">
					<div className="col-5 col-12-medium">
						<TextGroup
							rootProps={{ className: '' }}
							description={{
								text:
									isEn ? 'We would love to talk to you about how we can help turn your idea into reality.' : 'Adoraríamos falar consigo sobre como podemos ajudar a transformar a sua ideia numa realidade.',
							}}
						/>
						<TestimonialSmall
							{...testimonial}
							rootProps={{ className: 'testimonial-small bg-white off' }}
						/>
						<div className="company">
							<p>{isEn ? 'Trusted by' : 'Marcas que confiam em nós:'}</p>
							<div className="company-images">
								{_.map(companies, (company, i) => (
									<React.Fragment key={`${company.title}-${i}`}>
										<Image {...company} />
									</React.Fragment>
								))}
							</div>
						</div>
					</div>
					<div className="col-7 col-12-medium">
						{!message.status &&
							<form className="contact-form" onSubmit={handleSubmit(onSubmit)}>
								<div className="row">
									<div className="col-12">
										<label htmlFor="message" className="hide-mobile">
											{isEn ? 'How can we help? Please share a brief description of your project.' : 'Como podemos ajudar? Por favor descreva o seu projeto em poucas palavras.'}
										</label>
										<textarea
											{...register('message')}
											required
											rows="6"
											placeholder={isEn ? "Enter your message" : 'Escreva a sua mensagem'}
										/>
									</div>
									<div className="col-12">
										<label htmlFor="budget">{isEn ? 'What is your budget?' : 'Qual é o seu orçamento?'}</label>
										<select
											{...register("budget")}
											required
											placeholder={isEn ? 'Choose your budget:' : 'Escolha o seu orçamento'}
										>
											<option value="">{isEn ? '-Budget-' : '-Orçamento-'}</option>
											<option value="1.000€-10.000€">1.000€ - 10.000€</option>
											<option value="10.000€-50.000€">10.000€ - 50.000€</option>
											<option value="50.000€-100.000€">50.000€ - 100.000€</option>
											<option value="+100.000€">+ 100.000€</option>
										</select>
									</div>
									<div className="col-12">
										<input
											{...register("name")}
											required
											type="text"
											placeholder={isEn ? "Full Name" : 'Nome completo'}
										/>
									</div>
									<div className="col-12">
										<input
											{...register("email")}
											required
											type="email"
											placeholder="E-mail"
										/>
									</div>
									<div className="col-12-medium">
										<input
											type="checkbox"
											id="human"
											name="human"
											defaultChecked
											required
										/>
										<label htmlFor="human">
											{isEn ? 'I consent to log storing my data so they can respond to me.' : 'Autorizo ​​a log a guardar os meus dados para que me possam responder.'}
										</label>
									</div>
									<div className="col-12">
										<p>
											{isEn ? 'You\'re all done! Just click the button below and we\'ll reach out in less than 24 hours.' : 'Está pronto! Agora basta clicar no botão abaixo e entraremos em contacto consigo em menos de 24 horas.'}
										</p>
									</div>
									<div className="col-12">
										<Turnstile onToken={setTurnstileToken} />
									</div>
									<div className="col-12">
										<div className="submit">
											<input
												type="submit"
												value={isEn ? 'Send' : 'Enviar'}
												className="button secondary"
												disabled={!turnstileToken}
											/>
										</div>
									</div>
								</div>
							</form>
						}
						{message.status === 200 &&
							<div className="contact-form--success heading-large">
								<h2>
									{isEn ? 'Thank you for your email' : 'Obrigado pelo seu e-mail'}
								</h2>
								<p>
									{isEn ? 'we\'ll try to reach out in less than 24 hours.' : 'tentaremos entrar em contato em menos de 24 horas.'}
								</p>
							</div>
						}
						{message.status === 400 &&
							<div className="contact-form--error heading-large">
								<h2>
									There was an error with your email submition.
								</h2>
								<p>
									Please try again later.
								</p>
							</div>
						}
						{message.status === 500 &&
							<div className="contact-form--error heading-large">
								<h2>
									Unexpected error during email submition.
								</h2>
							</div>
						}
					</div>
				</div>
			</div>
		</section>
	)
}
export default ContactOne
